import React from "react"

// What Disable and Enable do, said before they are confirmed (the events list and the event page). A disabled event is a
// canceled one (CONTEXT, „Eveniment anulat”): CPanel keeps the word Disabled, the website marks it Canceled.
export const DisableEventCopy = ({ name }) => <>
  <p>{name} stays on the website, marked <strong>Canceled</strong>. Registrations and payments stop.</p>
  <ul className="list-unstyled mb-0">
    <li><i className="bx bx-envelope text-muted mr-1" aria-hidden="true" />The organizer receives the „Event canceled” email.</li>
    <li><i className="bx bx-lock-alt text-muted mr-1" aria-hidden="true" />Its logistics sheet becomes read-only.</li>
    <li><i className="bx bx-info-circle text-muted mr-1" aria-hidden="true" />For an event created by mistake, such as a duplicate, use Delete Event instead.</li>
  </ul>
</>

// Enable is offered only for a disabled event.
export const EnableEventCopy = ({ name }) =>
  <p>{name} is no longer marked Canceled on the website. Registrations and payments open again as its phases allow.</p>

// Delete is for an event created by mistake (CONTEXT, „Eveniment șters”); Events refuses the others, which are disabled instead.
export const DeleteEventRule = () =>
  <p className="text-muted mb-0">An event with paid entries or a shipped logistics parcel cannot be deleted.</p>
